(() => {
  const copyText = async (value) => {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.setAttribute('aria-hidden', 'true');
    input.style.position = 'fixed';
    input.style.top = '0';
    input.style.left = '-9999px';
    input.style.fontSize = '16px';
    document.body.appendChild(input);
    input.focus();
    input.select();
    input.setSelectionRange(0, input.value.length);

    let copied = false;

    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    input.remove();

    if (copied) return;

    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    throw new Error('Não foi possível copiar o cupom.');
  };

  const initDigiCouponCopy = (scope = document) => {
    scope.querySelectorAll('[data-digi-coupon-copy]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      const button = section.querySelector('[data-copy-coupon]');
      const status = section.querySelector('[data-copy-status]');

      section.dataset.initialized = 'true';
      if (!button) return;

      button.addEventListener('click', async () => {
        const coupon = button.dataset.copyCoupon;
        const label = button.querySelector('[data-copy-label]');
        const defaultLabel = button.dataset.defaultLabel || 'COPIAR';
        const successLabel = button.dataset.successLabel || 'COPIADO!';

        if (!coupon) return;

        try {
          await copyText(coupon);
          button.classList.add('is-copied');
          label.textContent = successLabel;
          if (status) status.textContent = `Cupom ${coupon} copiado.`;

          window.clearTimeout(button.digiCouponCopyTimer);
          button.digiCouponCopyTimer = window.setTimeout(() => {
            button.classList.remove('is-copied');
            label.textContent = defaultLabel;
            if (status) status.textContent = '';
          }, 1800);
        } catch (error) {
          label.textContent = 'TENTE NOVAMENTE';
          if (status) status.textContent = 'Não foi possível copiar o cupom.';

          window.clearTimeout(button.digiCouponCopyTimer);
          button.digiCouponCopyTimer = window.setTimeout(() => {
            label.textContent = defaultLabel;
            if (status) status.textContent = '';
          }, 2200);
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initDigiCouponCopy());
  document.addEventListener('shopify:section:load', (event) => initDigiCouponCopy(event.target));
})();
